(() => {
	angular
		.module('main')
		.controller('AmbassadorsController', AmbassadorsController);

	AmbassadorsController.$inject = [
		'$scope',
		'$rootScope',
		'$filter',
		'messageService',
		'ambassadorService',
		'ambassadorsDataService',
		'timeService'
	];

	function AmbassadorsController(
		$scope,
		$rootScope,
		$filter,
		messageService,
		ambassadorService,
		ambassadorsDataService,
		timeService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.ambassador = {};

			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'firstName',
					reverse: false
				},
				search: ''
			};

			$scope.ambassadors = [];
			$scope.totalItems = 0;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage)
				.then(successGetResultsPage)
				.catch(messageService.showDefaultErrorMessage);
		});

		$scope.editAmbassador = ambassador => {
			$scope.btn_disable = true;
			$scope.ambassador = angular.copy(ambassador);

			$('#addAmbassadorCodeModal').modal('show');
			$scope.btn_disable = false;
		};

		$scope.submitAmbassadorCode = ambassador => {
			$scope.btn_disable = true;
			const ambassador2save = ambassadorService.validateAmbassador(ambassador);

			if (!ambassador2save) {
				$scope.btn_disable = false;
				return;
			}

			ambassadorsDataService
				.updateAmbassador(ambassador2save)
				.then(() => {
					$('#addAmbassadorCodeModal').modal('hide');
					toastr.success('Ambassador saved', 'Success!');
					return ambassadorsDataService.getAmbassadors($scope.pageRequest);
				})
				.then(successGetResultsPage)
				.catch(messageService.showDefaultErrorMessage)
				.finally(() => {
					$scope.btn_disable = false;
				});
		};

		// get result page

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null
		) {
			let changed = false;

			if (predicate && reverse) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}

			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				return ambassadorsDataService.getAmbassadors($scope.pageRequest);
			}
			return false;
		}

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.pageRequest.search || '';
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			let pagesCount;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (let i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}

			$scope.ambassadors = angular.copy(data.results);

			if ($scope.ambassadors) {
				$scope.ambassadors = prepareAmbassadors($scope.ambassadors);
			}

			$scope.$evalAsync();
		}

		function prepareAmbassadors(ambassadors) {
			let ambassadors2Show = angular.copy(ambassadors);

			ambassadors2Show = timeService.convertDatesToUTC(
				$scope.ambassadors,
				'startDate',
				'endDate'
			);
			ambassadors2Show.forEach(ambassador => (ambassador.isAmbassador = true));

			return ambassadors2Show;
		}

		// navigation

		$scope.order = function(predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse =
					$scope.pageRequest.pageOrder.predicate === predicate
						? !$scope.pageRequest.pageOrder.reverse
						: false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.ambassadors = $filter('orderBy')(
				$scope.ambassadors,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage).then(successGetResultsPage);

			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null).then(successGetResultsPage);
			}
		};

		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null).then(
						successGetResultsPage
					);
				}
			}
		};

		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null).then(
						successGetResultsPage
					);
				}
			}
		};

		$scope.searchRequest = search => {
			$scope.pageRequest.search = search;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage).then(
				successGetResultsPage
			);
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/admin/ambassadorsController.js